import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { SellerApiService } from '../../service/seller-api.service';

@Component({
  selector: 'app-buyer-info',
  templateUrl: './buyer-info.component.html',
  styleUrls: ['./buyer-info.component.scss']
})
export class BuyerInfoComponent implements OnInit, OnChanges {

  buyerInformation: any = {};
  @Input() buyerId: number;
  constructor(private sellerService: SellerApiService) { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.buyerId != null && this.buyerId !== 0) {
      this.getBuyerInformationByBuyerId(this.buyerId);
    }
  }

  // Get the Buyer Information By Buyer Id

  getBuyerInformationByBuyerId(buyerid) {
    this.sellerService.getBuyerInformationByBuyerId(buyerid).subscribe(res => {
      this.buyerInformation = res;
      if (res.contact_no === '0') {
        this.buyerInformation.contact_no = null;
      }
      console.log(this.buyerInformation);
    }, err => {
      console.log(err);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/seller/sub-component/buyer-info/buyer-info.component.ts